import { useCallback } from "react";
import { useHistory } from "react-router";
import { USER_MODULE_ACTION, useUserModuleDispatch } from "..";
import { getHomeRoute } from "../../../routes/routes";

export default function useResetUser() {
    const dispatch = useUserModuleDispatch();
    const history = useHistory()

    return useCallback(() => {
        history.push(getHomeRoute());
        dispatch({
            type: USER_MODULE_ACTION.RESET
        });

    }, [dispatch, history]);
}
